import { useContext, useState } from "react";
import Chip from "../../../components/shared/chip/chip";
import { notifyError } from "../../../components/snackbar/snackbar";
import { apiContext } from "../../../contexts/apiContext";
import { CancelTaskResponse, DeleteTaskProps } from "../../../services/mainDatabaseService/types/mainDatabaseServiceProps";
import { DeleteTaskWindowProps } from "./types/deleteTaskWindowProps";
import InfoModal from "../../../components/modalWindow/infoModal";
import ConfirmModal from "../../../components/modalWindow/confirmModal";
import { ReactComponent as CancelIcon } from '../../../icons/cancel.svg';
import Modal from "../../../components/modalWindow/modal";
import ButtonField from "../../../components/buttonField/buttonField";
import { classNameBtn } from "../../../components/shared/button/types/buttonProps";
import TextAreaField from "../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../components/textAreaField/types/textAreaFieldProps";
import { configValidation } from "../../../helpers/validation/validation";
import Summary from "../../../components/summary/summary";
import { deleteTask } from "../../../services/mainDatabaseService/mainDatabaseService";
import "./deleteTaskWindow.scss";

const DeleteTaskWindow = (props: DeleteTaskWindowProps) => {
    const api = useContext(apiContext);
    const [confirmation, setConfirmation] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);
    const [summary, setSummary] = useState<CancelTaskResponse | null>(null);
    const [reason, setReason] = useState<string>('');
    const [reasonError, setReasonError] = useState<boolean>(false);

    const deleteObjectData = () => {
        return props.rows
            .map(row => row.original.attributes);
    }

    const confirm = () => {
        if (!reason) {
            setReasonError(true);
            return;
        }
        setConfirmation(false);
        setLoading(true);

        const accepted = deleteObjectData();
        let deleteProps: DeleteTaskProps = {
            dataBaseObjects: accepted,
            apiBase: api.apiUrl + api.apiVersion,
            reason: reason
        };

        deleteTask(deleteProps)
            .then((response: CancelTaskResponse) => {
                setSummary(response);
                setLoading(false);
            })
            .catch(() => {
                notifyError({ message: "Próba skasowania zadań zakończona niepowodzeniem" });
                props.onClose();
            });
    }

    const close = () => {
        if (!loading) {
            props.onClose(false);
        }
        if (summary !== null) {
            props.reload();
        }
    }

    const cancelClose = () => {
        if (!loading) {
            props.onClose(true);
        }
    }

    var validation: configValidation = {
        required: true,
        maxCharacters: {
            maxNumberOfCharacters: 1073741822,
            errorMsg: "Przekroczono limit 1 073 741 822 znaków"
        }
    }

    var textAreaProps: TextAreaFieldProps = {
        labelName: '',
        textAreaPlaceholder: 'Podaj przyczynę',
        value: reason,
        textareaSharedProps: {
            className: 'body-txt-medium',
            style: { width: '100%' }
        },
        configValidation: validation,
        disabled: false,
        setValue: (value: any) => {
            setReason(value);
        },
        validationError: reasonError,
        tipText: 'To pole jest wymagane',
        pristine: true
    }

    const question = (accepted: any[]) => {
        if (accepted.length === props.rows.length) {
            return <div className="deleteTask-question">
                <div>Aby usunąć wybrane obiekty podaj przyczynę.</div>
                <TextAreaField {...textAreaProps} />
            </div>
        }
        return <div className="deleteTask-question">
            <div>Wybrane obiekty, dla których operacja może zostać wykonana, zostaną usunięte. Aby usunąć wybrane obiekty podaj przyczynę.</div>
            <TextAreaField {...textAreaProps} />
            <div className="deleteTask-cards">
                {accepted.map(a => {
                    return <div className="deleteTask-tag"><Chip key={a.ID} title={a.NUMER_IDENTYFIKACYJNY} /></div>
                })}
            </div>
        </div>
    }

    if (confirmation) {
        const accepted = deleteObjectData();
        if (accepted.length === 0) {
            return (<InfoModal width={"660px"} height={"auto"}
                cancelTitle={"Zamknij"}
                onCancel={cancelClose}
                information="Brak możliwości skasowania wybranych kart."
            />)
        } else {
            return (
                <ConfirmModal width={"660px"} height={"auto"}
                    confirmTitle={"Potwierdź"}
                    onConfirm={confirm}
                    cancelTitle={"Anuluj"}
                    onCancel={cancelClose}
                    question={question(accepted)}
                />)
        }
    }

    return (
        <>
            <Modal
                title={"Kasuj KR i związane obiekty"}
                titleIcon={CancelIcon}
                iconClass='titleIconBlack'
                width={'100%'}
                height={'50vh'}
                actionBtns={summary !== null ? [
                    <ButtonField
                        key={1}
                        BtnProps={{
                            onClick: close,
                            className: `${classNameBtn.Btn} ${classNameBtn.Large} body-txt-medium`
                        }}
                        placeHolder="Zamknij"
                    />
                ] : []}
                onClose={close}>
                <Summary loading={loading} summary={summary} />
            </Modal>
        </>);
}

export default DeleteTaskWindow;